export default "__VITE_ASSET__BlHB9ByP__"